import { isArray } from 'util';
import { Role } from '../role';
import { RoleUserActivityBuilder } from './role-user-activity.builder';
import { PrivilegeBuilder } from './privilege.builder';

export class RoleBuilder {
  static fromJson(json) {
    return (json)
      ? new Role(
        json.code,
        json.name,
        json.operational,
        json.imagePath,
        RoleUserActivityBuilder.fromList(json.roleUserActivities),
        PrivilegeBuilder.fromList(json.privileges)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(RoleBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/role.builder.ts